// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"bd367c31","490":"f935bc8a"}[chunkId] + ".chunk.css";
};